import React from 'react'
import second from '../Styles/Search.css'
const Search = () => {
  return (
    <div className='mainDiv-search'>
      <h1>Search Results for</h1>
      <input></input>
      <p>No Results</p>
    </div>
  )
}

export default Search